import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import { CLEAR_REGIONS, FLAG_GETTING_REGIONS, GET_REGIONS } from '../../../actions/types/location/Region';


const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    error: null,
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_REGIONS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_REGIONS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_REGIONS:
      return state.setIn(['all', 'content'], INITIAL_STATE.getIn(['all', 'content']));
    default:
      return state;
  }
};